import { render } from "./EditRequestSummary.vue?vue&type=template&id=176faafa"
import script from "./EditRequestSummary.vue?vue&type=script&lang=js"
export * from "./EditRequestSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__